import React, { useState, useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useLanguage } from '../../i18n/LanguageContext';

const STORAGE_KEY = 'salient_cookie_consent';

const CookieConsent = () => {
    const { t } = useLanguage();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(STORAGE_KEY)) {
                const t = setTimeout(() => setVisible(true), 600);
                return () => clearTimeout(t);
            }
        } catch (e) {
            setVisible(true);
        }
    }, []);

    const decide = (value) => {
        try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* noop */ }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6">
            <div className="max-w-5xl mx-auto bg-salient-navy text-white rounded-2xl shadow-2xl border border-white/10 border-t-4 border-t-salient-green p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-5">
                <div className="flex items-start gap-4 flex-1">
                    <div className="w-11 h-11 flex-shrink-0 rounded-full bg-salient-green/15 border border-salient-green/40 flex items-center justify-center text-salient-green text-xl">
                        <i className="fas fa-cookie-bite"></i>
                    </div>
                    <p className="text-slate-300 text-sm leading-relaxed">
                        {t('cookie.textBefore')} <span className="text-white font-semibold">{t('cookie.acceptEmph')}</span> {t('cookie.textAfter')}
                    </p>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                    <button
                        onClick={() => decide('rejected')}
                        className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white border border-white/30 hover:border-white/60 transition-colors"
                    >
                        {t('cookie.reject')}
                    </button>
                    <button
                        onClick={() => decide('accepted')}
                        className="btn btn-accent text-sm px-6 py-2.5"
                    >
                        {t('cookie.accept')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
